import { PageBuilderService } from "./PageBuilderService";

export default PageBuilderService;